import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/service/common.service';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent implements OnInit {

  project;
  profile;

  showRoomSetting = false;

  constructor(public cm:CommonService) { 
    this.cm.getMessage().subscribe((massage)=>{
      if(massage.command == 'menu2'){
        this.clickMenu();
      }
    })
    
    
  }

  ngOnInit() {
    this.profile = this.cm.getProfile();
    this.project = this.cm.getProject();

  }

  isShowMenu = true;
  clickMenu(){
    this.isShowMenu = !this.isShowMenu;
    this.cm.sendMessage('menu',String(this.isShowMenu));
  }

  check_array_storage(data){
    if(data.constructor == Array){
      return true;
    }else {
      return false;
    }
  }

  save(){
    
  }

}
